export const constructDate = (date: Date, uk = true) => {
  return uk
    ? `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(
        -2
      )}/${date.getFullYear()}`
    : `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
        '0' + date.getDate()
      ).slice(-2)}`
}
